import { ComponentProps } from 'react';

import { TrackedNativeLink } from 'components/Link/TrackedNativeLink';

import { LegacyPrimaryButton } from './LegacyPrimaryButton';

export function TrackedPrimaryButtonLink(
  props: ComponentProps<typeof LegacyPrimaryButton> &
    ComponentProps<typeof TrackedNativeLink>,
) {
  return (
    <LegacyPrimaryButton
      component={TrackedNativeLink}
      type={null}
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  );
}
